import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ContractDetailsComponent } from '../../contracts/contract-details/contract-details.component';
import { PaymentsComponent } from '../payments.component';

@Component({
  selector: 'app-edit-payment',
  templateUrl: './edit-payment.component.html',
  styleUrls: ['./edit-payment.component.scss']
})
export class EditPaymentComponent implements OnInit {

  editPayForm: FormGroup;
  missingFieldMsg = false;
  errorMsg = false;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  @Input() installmentData: any

  constructor(private contractDetails: ContractDetailsComponent, private appComp: AppComponent, private formBuilder: FormBuilder, private authService: AuthenticationService, private payments: PaymentsComponent, private router: Router) { }

  ngOnInit(): void {
    // console.log(this.router.url);
    this.editPayForm = this.formBuilder.group({
      reference: [""],
      paid: [null, Validators.required],
    });
  }

  ngOnChanges() {   
    if(this.installmentData){
      this.editPayForm.patchValue({
        reference: this.installmentData.reference,
        paid: this.installmentData.paid
      })
    }
    
  }

  editPayment(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.editPayForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editPayForm.getRawValue();
    this.installmentData.reference = formObj.reference;
    this.installmentData.paid = formObj.paid;

    this.authService.editInstallment(this.installmentData).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      if(this.installmentData.details){
        this.contractDetails.getContractDetails();
      }else{
        this.payments.getInstallmentes();
      }
      
      this.appComp.loading = false;
    }, err =>{
      this.errorMsg = true;
      console.log(err);
      this.appComp.loading = false;
    })
  }

}
